<div class="downgrade-modal">
  @if (!downgradeResponse?.cleanup_required) {
    <button type="button" class="downgrade-modal-close" aria-label="Close" (click)="close()">
      <img src="assets/icons/icon-close.svg" alt="Close">
    </button>
  }

  <div class="downgrade-modal-icon" aria-hidden="true">
    <svg viewBox="0 0 24 24" width="26" height="26" fill="none">
      <circle cx="12" cy="12" r="9.2" stroke="currentColor" stroke-width="1.6" />
      <path d="M12 11v5.5" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" />
      <circle cx="12" cy="7.6" r="1" fill="currentColor" />
    </svg>
  </div>

  <h4 class="downgrade-modal-title">Account Downgrade</h4>
  <p class="downgrade-modal-body">Before we downgrade your subscription, we need to do some cleanup.</p>

  <div class="downgrade-modal-actions">
    <button type="button" class="btn btn-theme" (click)="next()">Next</button>
  </div>
</div>
